import Address from '@/locations/models/address'

export default class RegistrationRequest {
  public email = ''
  public role = ''
  public salutation = ''
  public title = ''
  public firstName = ''
  public lastName = ''
  public companyName = ''
  public address = new Address()
  public code = ''
  public password = ''
  public confirmPassword = ''
  public agbConfirmed = false
  public automaticNewsfeedEnabled = true
  public automaticNewsfeedEnabledForUnlocated = true
  public receiveNewsletters = true
  public phoneNumber = ''
}
